import React, { useEffect, useRef, useState } from 'react'
import { SingleCompanyGrid } from '../components'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Button, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Tab, Tabs, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { vdrHomeAction, vdrCompanyAction, vdrFavoriteAction, vdrMediaAction, segmentAction, vdrHomeCompaniesAction } from '../../redux/actions/VdrAction';
import { CustomCarousel, HomeSearch } from '../components';
import { getBaseLink, loggedInUser, wordLimit } from '../../constants/helpers';
import { LoadingComponent } from '../../components';
import { Link as SLink } from 'react-scroll'
import { Link, useNavigate } from 'react-router-dom';
import DrawerContainer from '../../components/Common/DrawerContainer';
import { motion } from 'framer-motion'
import MediaModel from '../../components/SingleCompanyContainer/MediaSection/MediaModel';
import { segmentAddJson } from '../../constants/defaultArray';





const HomePage = () => {

  const dispatch = useDispatch()
  const { data: homeData, loading: homeLoading } = useSelector((state) => state.vdrHomeReducer)
  const { data: companyData, loading: companyLoading, totalRows } = useSelector((state) => state.vdrCompanyReducer)

  const { data: userProfileData, loading: userProfileLoading } = useSelector((state) => state.userProfileReducer)


  const { isAuthenticated, isAdmin } = useSelector((state) => state.loginData);
  const [listingData, setListingData] = useState(null);
  const [listingGroup, setListingGroup] = useState([]);
  const [FavLoading, setFavLoading] = useState(false);


  const navigation = useNavigate();

  const companyDataView = () => {

  }

  const { data: FavoriteCompanyData, loading: FavoriteCompanyLoading, error: FavoriteCompanyError } = useSelector(state => state.FavoriteCompanyReducer);
  const { data: vdrFavoriteData, loading: vdrFavoriteLoading, error: vdrFavoriteError } = useSelector(state => state.vdrFavoriteReducer);


  const { data: vdrMediaData, loading: vdrMediaLoading } = useSelector((state) => state.vdrMediaReducer);
  const { data: SegmentData, loading: SegmentLoading } = useSelector((state) => state.SegmentReducer);

  const { data: vdrHomeCompaniesData, loading: vdrHomeCompaniesLoading } = useSelector((state) => state.vdrHomeCompaniesReducer);


  const [companyMasterArr, setCompanyMasterArr,] = React.useState([]);
  const [VideosArr, setVideosArr] = React.useState([]);

  const [company, setCompany] = React.useState([]);
  const [companyKey, setCompanyKey] = React.useState(false);
  const [cLoading, setCLoading] = React.useState(false);

  const selectCompany = () => {
    if (totalRows > 0) {
      var data1 = [];
      companyData.Data.map((item) => {
        var d1 = { title: item.company_name, name: item.company_name, value: item.company_id };
        data1.push(d1);
      })

      data1.sort(function (a, b) {
        if (a.title < b.title) { return -1; }
        if (a.title > b.title) { return 1; }
        return 0;
      })
      const unique = [...new Map(data1.map(item => [item['value'], item])).values()];
      // console.log('unique >> '+JSON.stringify(data1));
      setCompanyMasterArr(unique);
      setCLoading(true);
    }
  }



  useEffect(() => {
    if (vdrHomeCompaniesLoading) {
        dispatch(vdrHomeCompaniesAction({status: 1}));
    }
}, [dispatch, vdrHomeCompaniesLoading]);


  useEffect(() => {

    console.log('loggedInUser', userProfileData);
    // console.log('loggedInUser >>> ',JSON.parse(localStorage.getItem('users_leggin'))?.user_id);

    if (SegmentLoading) {
      dispatch(segmentAction(segmentAddJson));
    }


    if (FavLoading === false) {

      // if (vdrFavoriteLoading) {
      //   console.log('run vdrFavoriteLoading >>> ')

      //   dispatch(vdrFavoriteAction({
      //     "user_id": (loggedInUser?.user_id),
      //     "Inputtype": 2
      //   }));
      // }

      if (!vdrFavoriteLoading) {
        setFavLoading(true);
        var cmpDataaaaa = [];

        var homeDataData1 = vdrFavoriteData?.Data.map((item) => {
          var company_id = item.company_id;
          if (item.isFavorite && !cmpDataaaaa.includes(company_id)) {
            cmpDataaaaa.push(company_id.toString());
          }
        });
        // console.log('vdrFavoriteDsssssssata >>>>>', vdrFavoriteData?.Data)
        dispatch({
          type: 'FavoriteCompanySuccess',
          payload: cmpDataaaaa
        });

      }


    }


  }, [dispatch, vdrFavoriteLoading]);


  useEffect(() => {
    if (homeLoading) {
      dispatch(vdrHomeAction({ status: 1, user_id: (loggedInUser?.user_id) }))
    }
    if (companyLoading) {
      dispatch(vdrCompanyAction({ status: 1 }))
    }

    if (!homeLoading) {

      let homeDataArr = homeData.Data;
      let homeDataArr0 = [];
      // vdrHomeCompaniesData
      
      // console.log(vdrHomeCompaniesData);
      setListingData(homeDataArr)
      // const unique = [...new Set(homeDataArr.map(item => item.group_id))]; // [ 'A', 'B'] 
      const unique = [...new Map(homeDataArr.map(item => [item['group_id'], item])).values()]; // [ 'A', 'B'] 

      setListingGroup(unique)
    }
    // console.log(companyLoading);
    if (!companyLoading) {
      selectCompany()
    }
  }, [dispatch, homeLoading, companyLoading]);

  useEffect(() => {

    if (vdrMediaLoading) {
      var videoParams = {
        "userid": 1,
        "videoCode": "",
        "videoId": "",
        "videoType": "",
        "videoTitle": "",
        "videoDescription": "",
        "DocumentType": "Common",
        "isFeatured": true,
        "inputType": 2
      }
      dispatch(vdrMediaAction(videoParams));
    }

    if (!vdrMediaLoading) {
      setVideosArr(vdrMediaData.Data.filter((items) => { if (items.DocumentType === "Common" && items.isFeatured === true) return items }));
    }

  }, [dispatch, vdrMediaLoading]);


  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    console.log(newValue);
    setValue(newValue);
  };

  const [anchor, setAnchor] = React.useState('left');
  const [stateDrawer, setStateDrawer] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [openForm, setOpenForm] = React.useState(null);
  const [SideDraw, setSideDraw] = React.useState(true);
  const [parentGroup, setParentGroup] = React.useState(null);
  const toggleDrawer = (anchor, open) => (event) => {

    if (event) {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
    }
    setStateDrawer({ ...stateDrawer, [anchor]: open });
  };



  var group_id;

  if (homeLoading) {

    return (
      <LoadingComponent />
    )
  }

  const motionVariant = {
    open: {
      x: 0,
      opacity: 1,
    },
    close: {
      opacity: 0,
      x: -100,
    },
  }


  const groupViewData = (groupItem, gIndex, segment_id, disabledLink="") => {
    
    if(groupItem.group_id == 4){
      disabledLink = true;
    }

    return (
      <>
      {/* {
        !segment_id && groupItem?.group_name.toLowerCase() == 'exit' ?
          <Divider sx={{ backgroundColor: '#3e3e3e', height: 3 }} />
          :
          null
      } */}

      <Box sx={{
        margin: '20px 0'
      }} key={gIndex} id={`container${gIndex}`}>
        <Box
          sx={{
            display: 'flex',
            padding: '0 0.8rem'
          }}
          justifyContent="space-between"
          alignItems={'center'}
        >
          <Typography variant="h6" >
            {groupItem.group_name}
            {/* {groupItem.group_id} */}
          </Typography>

          {
            groupItem?.company_length > 5
              ?
              <>
                <Button variant="text">
                  See &nbsp;More
                </Button>
              </>
              :
              null
          }
        </Box>

        <CustomCarousel disabledLink={disabledLink} groupId={groupItem.group_id} EnableNumber={groupItem?.enable_number} listingData={listingData} />

      </Box>
      {/* {
       !segment_id && gIndex == 3 ?
          <Divider sx={{ backgroundColor: '#3e3e3e', height: 3 }} />
          :
          null
      } */}
    </>
    )
  }

if((userProfileData && !userProfileData?.user?.is_vdr && isAdmin !== "administrator") || (loggedInUser && !loggedInUser?.data?.user?.is_vdr && isAdmin !== "administrator")){
  // console.log('loggedInUser >>> ')
  // console.log('userProfileData >>> ', userProfileData)
  return (
    <>
    <Box
        className='headerContainerFront'
      >
        <Typography variant='h1' fontSize={'1.5em'} fontWeight="600"  style={{ zIndex: 1 }} >
          Please contact us for the subscription or drop an email at <a href="mailto:info@asascapital.com">info@asascapital.com</a> 
        </Typography>
      </Box>
    </>
  )
}


  return (
    <>

      <Box
        className='headerContainerFront'
      >
        
        <Typography variant='h1' fontSize={'2.5em'} fontWeight="600" color="#B79238" style={{ zIndex: 1 }} >
          Data Room
        </Typography>

        <HomeSearch sx={{
          minWidth: '50%',
          backgroundColor: '#fff', zIndex: 2, marginTop: 2, marginBottom: 2,
        }} newOptions={companyMasterArr} />


      </Box>
      
      

      <Box
        className='bodyContainer'
      >
          {
              listingGroup &&
              listingGroup.map((groupItem, gIndex) => {
                  return groupViewData(groupItem, gIndex);
              })
          }
        <MediaModel />

      </Box>

    </>
  )
}

export default HomePage